import { ToothChartStage } from '@/components/dental/ToothChartStage';
import { HistoryPanel } from '@/components/dental/history/HistoryPanel';

// ── Props ─────────────────────────────────────────────────────────────────────

interface HistoryRouteProps {
  patientId: string;
  clinicId: string;
}

// ── Component ─────────────────────────────────────────────────────────────────

export function HistoryRoute({ patientId, clinicId }: HistoryRouteProps) {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      {/* Chart — read-only, muted */}
      <div className="flex-none p-4 lg:p-6 opacity-80">
        <ToothChartStage
          patientId={patientId}
          clinicId={clinicId}
          readOnly
        />
      </div>

      {/* History panel */}
      <div className="border-t border-ds-line flex-1 min-h-0 overflow-hidden">
        <HistoryPanel
          patientId={patientId}
          clinicId={clinicId}
          className="h-full"
        />
      </div>
    </div>
  );
}
